import { render, staticRenderFns } from "./CreateSandModal.vue?vue&type=template&id=2c1ab6ac&scoped=true"
import script from "./CreateSandModal.vue?vue&type=script&lang=js"
export * from "./CreateSandModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1ab6ac",
  null
  
)

export default component.exports